import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialMessage: null,
};

export const counterSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    notification: (state, action) => {
      state.initialMessage = action.payload;
    },
    deleteNotify: (state, action) => {
      state.initialMessage = action.payload;
    },
  },
});

export const { notification, deleteNotify } = counterSlice.actions;
export default counterSlice.reducer;
